import { Navigate, useLocation } from 'react-router-dom';
import Layout from './layout/Layout';
import NotFound from '../pages/NotFound';
import { isProtectedAppPath } from '../utils/publicAccessPaths';

/** 未ログイン時の /* フォールバック: 保護ルートのみ /login、それ以外は 404 */
export default function UnauthenticatedCatchAll() {
  const location = useLocation();

  if (isProtectedAppPath(location.pathname)) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <Layout>
      <NotFound />
    </Layout>
  );
}
